export function renderError(lista, mensaje = 'Error en el servidor') {
  return { data: { [lista]: [], error: true, mensaje } };
}

export function evalAction(data, lista) {
  console.log('data.estadoTrama',data.estadoTrama);
  if (data.estadoTrama === '1' ) {
    return { data };
  } else if (data.estadoTrama === '0') {
    return renderError(lista, data.mensaje);
  }

  if (data.estadoTrama === undefined ) {
    return { data };
  }
  return renderError(lista);
}

export function serverError(error, lista) {
  if (error.response) {
    if (error.response.status === 401) {
      window.history.pushState({}, '', '/sidweb/login/');
      window.location.reload();
    }
    return renderError(lista, `${error.response.status} ${error.response.statusText}`);
  }

  return renderError(lista);
}



// WEBPACK FOOTER //
// ./src/utils/actionError.js